export type CarrierLike = {
  id: string;
  manuallyCreated: boolean;
};

export type CarrierRecord = {
  id: string;
  manuallyCreated: boolean;
};

export const getCarrierId = (carrier: CarrierLike): string => {
  return (carrier.id || "").trim();
};

export const toCarrierIds = (carriers: CarrierLike[]): string[] => {
  if (!Array.isArray(carriers)) {
    return [];
  }

  return carriers.map(getCarrierId).filter((carrierId) => Boolean(carrierId));
};
